import { SetStateAction } from "react";
import { useState } from "react";
import { ModalWithButtons } from "./modal";
import { BlueButton, WhiteButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";
import { CustomTextInput } from "../inputs";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function DeleteSpecificationConfirmModal(props: Props) {
	const { t: translation } = useTranslation();
	const [userInput, setUserInput] = useState("");

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<WhiteButton
					key="discard-order-cancel-button"
					id="discard-order-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></WhiteButton>,
				<BlueButton
					key="discard-order-proceed-button"
					id="discard-order-proceed-button"
					children={translation("Delete")}
					disabled={userInput !== translation("Delete")}
					onClick={() => {
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></BlueButton>,
			]}
		>
			<div className="modal-body-content">
				<div className="modal-body-icon discard-order-icon"></div>

				<div className="typography-body-01 typography-bold">
					{translation("DeleteFile?")}
				</div>
				<div
					className="typography-body-01"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("DeleteConfirmMessage")}
				</div>
				<div
					className="typography-body-01"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("CannotUndoAction")}
				</div>
				<div
					style={{
						marginTop: "5px",
					}}
				>
					<CustomTextInput
						id="delete-specification-confirm-input"
						label={""}
						value={userInput}
						setValue={setUserInput}
						placeholder={translation("Delete")}
						required
					/>
				</div>
			</div>
		</ModalWithButtons>
	);

	return modal;
}
